module.exports = __webpack_public_path__ + "img/HQ-OA-360V01TGU_ALL.27242a47.jpg";